import { jwtDecode } from "jwt-decode";

export const getClinicIdFromToken = () => {
  const token = localStorage.getItem("token");
  if(!token) return null;
  try {
    const decodedToken = jwtDecode(token);
    const clinicIds = decodedToken.clinic_ids;

    if (clinicIds && Array.isArray(clinicIds) && clinicIds.length > 0) {
      if (clinicIds.length === 1) {
        return clinicIds[0];
      } else {
        return clinicIds[clinicIds.length - 1];
      }
    } else {
      console.error("No clinic IDs found in the token");
      return null;
    }
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const getValueFromToken = (key) => {
  const token = localStorage.getItem("token");

  if (token) {
    try {
      const decodedToken = jwtDecode(token);

      if (decodedToken && decodedToken.hasOwnProperty(key)) {
        return decodedToken[key];
      } else {
        console.error("Token does not contain the specified key:", key);
        return null;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  } else {
    console.error("Token not found in localStorage");
    return null;
  }
};

export const getToken = () => {
  const token = localStorage.getItem("token");
  if(!token) return null;
  return token;
};

export const isTokenExpired = () => {
  const token = getToken();
  if (token) {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
  }
  return true;
};
